module.exports = __webpack_public_path__ + "img/step2-fr.f27c65f9.webp";